/**
 * NovelMello 品牌 - Book 页面配置
 * 设计 token 见 plans/8/新站NovelMello/00-overview.md
 * 完全独立：不引用其他品牌的页面配置，取值全部落成 NovelMello 自己的字面量。
 */
import { commonTexts } from './common'
import type { BookPageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

/** 主色 pink */
const PINK = '#F0509B'
/** 辅主色 purple */
const PURPLE = '#7C4DE8'

export const theme = {
  // 引言区引号颜色（设计：粉色实心引号）
  quoteColor: brandTheme.primaryColor || PINK,
  // 目录弹窗锁图标（ink-3）
  tocLockColor: '#AB9BB8',
  // 底部 Start Reading 胶囊渐变
  startReadingBg: brandTheme.primaryGradient || `linear-gradient(90deg, ${PINK} 0%, #9B5CF0 100%)`,

  // hero 浅渐变
  heroGradient: 'linear-gradient(170deg, #FDE8F1 0%, #EDE4FD 100%)',
  // 白卡投影
  cardShadow: '0 4px 16px rgba(124, 77, 232, 0.08)',
  // 辅助紫（Read more / Free / 上滑提示）
  accentColor: PURPLE,
  // 标签 chip 交替底色：pink-soft / purple-soft
  chipBgs: ['#FDEFF6', '#F3EDFE'],
  // 第一章预览正文色
  bodyColor: '#4A3D52',
  // 底部操作条上投影
  bottomBarShadow: '0 -4px 16px rgba(124, 77, 232, 0.08)',
  // 封面投影
  coverShadow: '0 10px 28px rgba(124, 77, 232, 0.2)',
  // 卡内分割线
  cardDividerColor: '#F2EAF4',
  // 上滑提示由 BookPage.novelmello.vue 内联渲染在第一章预览卡里
  swipeUpInline: true,
} as const

export const bookConfig: BookPageConfig = {
  theme,
  texts: commonTexts,
}
